export default __webpack_public_path__ + "navigation-examples-custom-server-thumbnail-v1-480-415f6dc6059e3c7d9a703fbd8ea952b1.webp";